<template>
  <q-card style="q-pa-md">
    <q-card-section
      ><q-icon name="person_remove" color="red" />
      <div class="text-h6 text-red">Birakan Danisanlar</div>
    </q-card-section>
    <q-card-section>
      Son 4 ay icerisinde randevusu olup, son 2 ay icerisinde randevusu olmayan
      danisanlar.
    </q-card-section>
    <q-card-section class="q-pt-none"
      ><q-list bordered separator>
        <q-item v-for="customer in customers" :key="customer.id">
          <q-item-section>
            <q-item-label
              >Danisan Kayit Tarihi:
              <span class="text-weight-light text-italic">
                {{ timetravel.humanReadableDate(customer.createdAt) }}</span
              ></q-item-label
            >
          </q-item-section>
          <q-item-section>
            <q-item-label>
              <span class="text-weight-medium">{{ customer.name }}</span>
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list></q-card-section
    >
  </q-card>
</template>
<script>
import { ref } from 'vue'
import axios from 'axios'
export default {
  setup() {
    const customers = ref([])
    axios
      .get(`/customers/leaving`)
      .then((response) => {
        customers.value = response.data
      })
      .catch(() => {})
    return {
      customers,
    }
  },
}
</script>
